import styled from 'styled-components';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const StyledLinkAddressWrapper = styled.div`
  margin-top: 0.5rem;
`;
